import React from 'react';

/** Corner-down-right arrow "↳" — the suggested-actions row marker. */
export const CornerDownRight: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.02 9.98H6.68C4.85 9.98 3.35 8.52 3.35 6.73V3.32"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.32 7.29L14.02 9.98L11.32 12.68"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
